import { useCardPreloadStore } from '../providers/CardPreloadProvider';
export const useAppId = () => {
  const appId = useCardPreloadStore(store => store.appId);
  return appId;
};